import React, { useState } from "react";
import { Button, CloseButton, Form, Offcanvas } from "react-bootstrap";
import Tick from "assets/svgs/tick";
import _ from "lodash";
import LeadOrder from "modules/dashboards/feedback_form/LeadOrder";
import {
  buttonStyle,
  formRow,
  selected,
} from "modules/dashboards/feedback_form/commonFunction";
import CallResponse from "modules/dashboards/feedback_form/CallResponse";
import SaveFeedBack from "modules/dashboards/feedback_form/SaveFeedBack";
import CallType from "modules/dashboards/feedback_form/CallType";
import LeadSLotBooking from "modules/dashboards/feedback_form/LeadSlotBooking";
import { v4 as uuidv4 } from "uuid";
import LeadSlotProbeQuestion from "modules/dashboards/feedback_form/LeadSlotProbeQuestion";
import { DISP_FLAG } from "../utilities/utility";

function LeadSlotDisposition({
  week,
  customerId,
  bookingId,
  id,
  setData,
  setBooking,
  customer
}) {
  const [show, setShow] = useState(false);
  const [isValid, setIsValid] = useState(true);
  const [formData, setFormData] = useState({
    callResponse: null,
    comments: null,
  });
  const [filterSlotData, setFilterSlotData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const sessionId = uuidv4();

  const renderedComponents = [
    { name: "callResponse", value: formData.callResponse },
  ];

  const handleShow = () => setShow(true);
  const handleClose = () => {
    setSelectedDate(null);
    setFilterSlotData(null);
    setSelectedSlot(null);
    setShow(false);
  };

  const handleChange = (event) =>{
    const {name, value}= event.target;
    setFormData((prev)=>{
      return {...prev,
        [name]:value
      }
    })
  }

  return (
    <>
      <Button className="flex-1" onClick={() => handleShow("lg-down")}>
        <Tick />
      </Button>
      <Offcanvas
        show={show}
        placement={"end"}
        style={{ width: DISP_FLAG ?"77%":"40%" }}
        onHide={handleClose}
      >
        <Offcanvas.Header CloseButton>
          <Offcanvas.Title>Add Feedback</Offcanvas.Title>
          <CloseButton
            className="btn btn-circle btn-sm transition-base p-0"
            onClick={handleClose}
          />
        </Offcanvas.Header>
        <Offcanvas.Body
          style={{ maxHeight: "85vh", overflowY: "scroll" }}
          className="scrollable-container"
        >
          <div className="d-flex gap-3 flex-row">
            <div>
            {DISP_FLAG &&<DispositionComponent customer={customer} />}
            </div>
          <div>
            <CallResponse
              formData={formData}
              buttonStyle={buttonStyle}
              selected={selected}
              setFormData={setFormData}
              formRow={formRow}
              isValid={isValid}
              bookingId={bookingId}
            />
            {formData.callResponse === "answered" && (
              <div>
                <LeadSlotProbeQuestion
                  formData={formData}
                  setFormData={setFormData}
                />
              </div>
            )}
            {formData.callResponse === "answered" && (
              <div>
                <LeadOrder
                  formData={formData}
                  buttonStyle={buttonStyle}
                  selected={selected}
                  setFormData={setFormData}
                  formRow={formRow}
                />
              </div>
            )}

            {(["answered", "unanswered"].includes(formData.callResponse) &&
              (formData.order_status === "order_not_placed" || formData.callResponse=="unanswered")) && (
                <div className="d-flex flex-column gap-1">
                  <CallType
                    formData={formData}
                    buttonStyle={buttonStyle}
                    selected={selected}
                    setFormData={setFormData}
                    formRow={formRow}
                  />
                 {formData.callResponse !== "unanswered" && <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Label>Order not Placed Reason</Form.Label>
                    <Form.Control
                      as="textarea"
                      name="order_not_placed_reason"
                      rows={3}
                      onChange={handleChange}
                    />
                  </Form.Group>}
                </div>
              )}
            {["answered", "unanswered"].includes(formData.callResponse) &&
              (formData.order_status === "order_not_placed" || formData.callResponse=="unanswered") &&
              formData.call_type === "hot" && (
                <div className="py-2">
                  <div className="font-poppins fs-1 text-black">
                    Please Select Follow up Call Time!
                  </div>
                  <LeadSLotBooking
                    caseId={customerId}
                    filterSlotData={filterSlotData}
                    setFilterSlotData={setFilterSlotData}
                    selectedDate={selectedDate}
                    setSelectedDate={setSelectedDate}
                    selectedSlot={selectedSlot}
                    setSelectedSlot={setSelectedSlot}
                    sessionId={sessionId}
                    slotBooking={true}
                    handleClose={handleClose}
                  />
                </div>
              )}

            {formData.callResponse === "answered" && formData.order_status && (
              <SaveFeedBack
                setShow={setShow}
                bookingId={bookingId}
                week={week}
                formData={formData}
                selected={selected}
                buttonStyle={buttonStyle}
                formRow={formRow}
                renderedComponents={renderedComponents}
                id={id}
                customerId={customerId}
                setData={setData}
                setBooking={setBooking}
              />
            )}
            {["unanswered", "languageIssue"].includes(formData?.callResponse) && (
              <SaveFeedBack
                setShow={setShow}
                bookingId={bookingId}
                week={week}
                formData={formData}
                selected={selected}
                buttonStyle={buttonStyle}
                formRow={formRow}
                renderedComponents={renderedComponents}
                id={id}
                customerId={customerId}
                setData={setData}
                setBooking={setBooking}
              />
            )}
          </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default LeadSlotDisposition;
